import { useAppVersion } from 'contexts/AppVersionContext';
import React from 'react';

const style = { fontWeight: 600, marginTop: 8 };

const AppVersion = () => {
    const { currentVersion } = useAppVersion();

    return (
        <div className="app-version" style={style}>
            {currentVersion}
        </div>
    );
};

export default AppVersion;
